import type {LineIngredientSource} from '../domain/line-ingredient-candidate';
import type {SavedMealId} from '../domain/saved-meal-id.value-object';

export const keys = {
  listAll: () => ['saved-meals', 'list'] as const,
  list: (q: string) => [...keys.listAll(), q] as const,
  picker: (q: string, limit: number) => [...keys.listAll(), 'picker', q, limit] as const,
  detail: (id: SavedMealId) => ['saved-meals', 'detail', id] as const,
  lineCandidatesAll: () => ['saved-meals', 'line-candidates'] as const,
  lineCandidates: (q: string, brand: string | null, source: LineIngredientSource | null) =>
    [...keys.lineCandidatesAll(), 'search', q, brand, source] as const,
  lineCandidateByBarcode: (barcode: string | null, source: LineIngredientSource | null) =>
    [...keys.lineCandidatesAll(), 'barcode', barcode, source] as const,
  recentItemsAll: () => ['saved-meals', 'recent-items'] as const,
  recentItems: (limit: number) => [...keys.recentItemsAll(), limit] as const,
  mutations: {
    create: () => ['saved-meals', 'mutations', 'create'] as const,
    update: () => ['saved-meals', 'mutations', 'update'] as const,
    delete: () => ['saved-meals', 'mutations', 'delete'] as const,
    touch: () => ['saved-meals', 'mutations', 'touch'] as const,
    clearRecentItems: () => ['saved-meals', 'mutations', 'clear-recent-items'] as const,
  },
} as const;
